<label
  [attr.for]="labelFor || null"
  [ngClass]="labelColClasses"
  [class.required]="required"
>
  <ng-container *ngIf="label">{{ label | translate }}</ng-container>
  <app-help-icon
    *ngIf="helpPageName"
    [helpPageName]="helpPageName"
  ></app-help-icon>
  <ng-content select="[label-extra]"></ng-content>
</label>

<div
  *ngIf="inputColClasses !== 'none'"
  class="form-row-input"
  [ngClass]="inputColClasses"
>
  <ng-content></ng-content>
</div>

<!-- Optional second label + control pair on the same row -->
<label
  *ngIf="label2"
  [attr.for]="label2For || null"
  [ngClass]="label2ColClasses"
  >{{ label2 | translate }}</label
>
<div *ngIf="label2" class="form-row-input" [ngClass]="input2ColClasses">
  <ng-content select="[second-control]"></ng-content>
</div>

<!-- Additional custom columns projected as direct row children -->
<ng-content select="[extra-col]"></ng-content>
